module.exports = __webpack_public_path__ + "media/images/elephant_ui_plane-58b155311d1962c0225f81f930355958.svg";